import { render, staticRenderFns } from "./ActivityLogsModal.vue?vue&type=template&id=f50b6f54"
import script from "./ActivityLogsModal.vue?vue&type=script&lang=js"
export * from "./ActivityLogsModal.vue?vue&type=script&lang=js"
import style0 from "./ActivityLogsModal.vue?vue&type=style&index=0&id=f50b6f54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports